import React, { useContext } from "react";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import FormPage from "../../common/formpage/formpage";
import AvatarHeader from "../../common/avatar-header/avatar-header";
import { useGameFormData } from "../../../hooks/useGameFormData";
import { useGameForm } from "../../../hooks/useGameForm";
import { GameContext } from "../../../contexts";
import { useTranslation } from "react-i18next";
import FakeButton from "@/components/fake-button";

const Minors = () => {
  const formData = useGameFormData();
  const { submit } = useContext(GameContext);

  const { t } = useTranslation("game", { keyPrefix: "minors" });

  function gameSubmit() {
    return { code: "game/ackMinor", body: {} };
  }

  const { handleSubmit, avatarHeaderProps } = useGameForm({
    gameSubmit,
    playerState: formData.playerState,
  });

  return (
    <Waitable
      playerActionHandler={submit}
      waitingFor={[GameStatus.GameStatusPostMinors]}
      waitHeader={t("waiting")}
    >
      <FormPage
        header={
          <AvatarHeader
            titles={[t("headers.default")]}
            {...avatarHeaderProps}
          />
        }
        {...formData}
        readyFlash
        submitText={t("footer.submit")}
        onSubmit={handleSubmit}
      >
        <div className={"grow flex justify-center items-center px-2"}>
          <FakeButton size="4xl" className="p-4 flex justify-center items-center text-center">
            <p>
              reminder! <br />
              there are players under 18 in this session. <br />
              <br />
              As per our{" "}
              <a href={"/codeofconduct"} target={"_blank"} rel={"noreferrer"}>
                code of conduct
              </a>
              , Do not include mature content in these stories.
            </p>
          </FakeButton>
        </div>
      </FormPage>
    </Waitable>
  );
};

export default Minors;
